import Vue from 'vue'
import Vuex from 'vuex'
import settings from './settings'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import Vuetify from '@/plugins/vuetify'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        'darkMode'
      ]
    })
  ],
  state: {
    geoportals: undefined,
    gminy: undefined,
    currentLanguage: 'pl',
    darkMode: undefined
  },
  mutations: {
    setDarkMode (state, newValue) {
      state.darkMode = newValue
      Vuetify.framework.theme.dark = state.darkMode // Refresh Vuetify color
    },
    setGeoportals (state, newValue) {
      state.geoportals = newValue
    },
    setGminy (state, newValue) {
      state.gminy = newValue
    }
  },
  actions: {
    async loadGeoportals (context, { config, filePath }) {
      try {
        const response = await axios.get(filePath)
        if (config === 'geoportals') {
          context.commit('setGeoportals', response.data)
        } else if (config === 'gminy') {
          context.commit('setGminy', response.data)
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  modules: {
    settings: settings
  }
})
